export var views = {
  single: 'single',
  flipping: 'flipping'
};
export var types = ['default', 'warning'];
export var directions = {
  next: 'next',
  prev: 'prev'
};
export var colorMap = {
  default: 'b600',
  warning: 'o600'
};